import Recognition from '../src/Recognition/index';
export default Recognition;
